import { BlackJackBetMoveEffect } from './../component/bj_bet_move_effect';
import { BlackJackSeatInfo, ButtonState, BlackJackGameState, BlackJackChipPos, BlackJackCardState, BlackJackBetType, GameResultState } from './black_table_data';
import Utility from "../../../../utility/utility";
import BlackJackTableView from "./blackjack_table_view";
import BlackJackUtility from "../../Utility/blackJack_utility";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import { BlackJack } from '../../net/proto/proto_blackjack_game';
import ModuleManager from '../../../../framework/core/module_manager';
import BlackJackTableLogic from './blackjack_table_logic';
import LanguageManager from '../../../../manager/language_manager';
import GameUtil from '../../../../utility/game_util';

const { ccclass, property } = cc._decorator;

@ccclass
export default class BlackJackTableBetView extends cc.Component {



    @property(cc.Button)
    seatBtn: cc.Button = null;

    @property(cc.Button)
    sideBetBtn: cc.Button = null;

    @property(cc.Label)
    singlePointTxt: cc.Label = null;

    @property(cc.Label)
    leftPointTxt: cc.Label = null;

    @property(cc.Label)
    rightPointTxt: cc.Label = null;

    @property(cc.Label)
    leftBaseNumTxt: cc.Label = null;

    @property(cc.Node)
    leftCoinBg: cc.Node = null;

    @property(cc.Label)
    rightBaseNumTxt: cc.Label = null;

    @property(cc.Node)
    rightCoinBg: cc.Node = null;

    @property(cc.Node)
    buttons: cc.Node = null;

    singlePoint: number = 0

    leftPoint: number = 0

    rightPoint: number = 0

    @property(cc.Node)
    pokerPos: cc.Node = null;

    @property(cc.Node)
    leftPokerPos: cc.Node = null;

    @property(cc.Node)
    rightPokerPos: cc.Node = null;

    @property(cc.Node)
    singlePointNode: cc.Node = null;

    @property(cc.Node)
    leftPointNode: cc.Node = null;

    @property(cc.Node)
    rightPointNode: cc.Node = null;

    @property([cc.Node])
    lights: cc.Node[] = [];

    @property(cc.Node)
    otherBet: cc.Node = null

    @property(cc.Node)
    curSelect: cc.Node = null

    @property(cc.Node)
    ohterBetLight: cc.Node = null

    @property(cc.Label)
    ohterBetTxt: cc.Label = null

    @property(BlackJackBetMoveEffect)
    baseEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    pairEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    threeEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    sideEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    insuranceEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    bankEffect: BlackJackBetMoveEffect = null

    @property(BlackJackBetMoveEffect)
    baseRightEffect: BlackJackBetMoveEffect = null


    // @property(cc.Animation)//
    // bombEffect: cc.Animation=null

    // @property(cc.Animation)//
    // bombLeftlEffect: cc.Animation=null

    // @property(cc.Animation)//
    // bombRightlEffect: cc.Animation=null
    // //===========================================
    // @property(cc.Animation)//
    // pointBgEffect: cc.Animation=null

    // @property(cc.Animation)//
    // pointBgLeftleEffect: cc.Animation=null

    // @property(cc.Animation)//
    // pointBgRightEffect: cc.Animation=null

    //===============================================
    // @property(cc.Animation)//
    // bjEffect: cc.Animation=null

    // @property(cc.Animation)//
    // dragonEffect: cc.Animation=null

    // @property(cc.Animation)//
    // dragonLeftEffect: cc.Animation=null

    // @property(cc.Animation)//
    // dragonRightEffect: cc.Animation=null

    //===============================================

    //存储poker预制 方便以后分牌操作
    pokerPrefabList: PokerTablePokerBase[] = [];


    private blackJackView: BlackJackTableView = null;

    parentNode: cc.Node = null;

    curBetSetp: number = 0;//0代表普通下注 1代表完美对子 2代表21+3




    //lastBetList:string[]=["","",""];
    sideBetInfo: BlackJack.Player.IBetInfo = null
    posInfoArr: BlackJack.IPosInfo[] = []
    seatNo = 0;


    mainPlayerInfo: BlackJack.IPlayer = null
    blackjackLogic: BlackJackTableLogic = null;
    chipPosList: cc.Node[] = []

    
    start() {

    }
    reset() {

        this.singlePointTxt.string = ""
        this.leftPointTxt.string = ""
        this.rightPointTxt.string = ""
        this.curBetSetp = 0

        this.otherBet.active = false;

        this.pokerPrefabList = []
        this.leftCoinBg.active = false;
        this.rightCoinBg.active = false;
        this.leftCoinBg.position = new cc.Vec2(0, -77)
        this.rightCoinBg.active = false;
        this.leftBaseNumTxt.string = "0"
        this.rightBaseNumTxt.string = "0"

        this.leftPointNode.active = false
        this.rightPointNode.active = false;
        this.singlePointNode.active = false;
        this.curSelect.active = false;
        this.lightsRest();
        this.buttons.active = false;
        this.clearBetData()
        this.pokerPos.destroyAllChildren();
        this.pokerPos.position = new cc.Vec2(-11, 150)

        this.leftPokerPos.destroyAllChildren();
        this.leftPokerPos.position = new cc.Vec2(-83, 150)
        this.rightPokerPos.destroyAllChildren();
        this.baseEffect.recycleAllBet()
        this.pairEffect.recycleAllBet()
        this.threeEffect.recycleAllBet()
        this.sideEffect.recycleAllBet()
        this.bankEffect.recycleAllBet()
        this.insuranceEffect.recycleAllBet()
        this.baseRightEffect.recycleAllBet()

        if (this.posInfoArr.length > 0) {
            if (this.posInfoArr[0].isMainSeat)
                this.posInfoArr.length = 1;
            else
                this.posInfoArr.length = 0
        }

        this.bindBtnClickEvent();
    }
    
    clearBetData() {
        for (let i = 0; i < this.posInfoArr.length; i++) {
            this.posInfoArr[i].base = 0
            this.posInfoArr[i].pair = 0
            this.posInfoArr[i].insuranceFlag = false
            this.posInfoArr[i].insurance = 0
            this.posInfoArr[i].b21p3 = 0
            if (i == 0 && this.posInfoArr[i].isMainSeat) {
                this.buttons.active = true;
            }
            this.posInfoArr[i].cardInfo = null
        }
        this.sideBetInfo = null
    }
    lightsRest() {
        for (let i = 0; i < this.lights.length; i++) {

            this.lights[i].active = false;
        }
    }
    bindBtnClickEvent() {

        this.seatBtn.node.on('click', this.on_click, this)
        //this.sideBetBtn.node.on('click', this.on_click, this)

    }

    unbindBtnClickEvent() {
        this.seatBtn.node.targetOff(this)
    }

    protected on_click(event: cc.Button): boolean {

        let isClickValid = Utility.btnClickValid(100)
        if (!isClickValid) {
            return isClickValid
        }
        Utility.playButtonSound()
        let node: cc.Node = event.node
        if (node == this.seatBtn.node) {
            this.seatBtnOnClick()
        } else if (node == this.sideBetBtn.node) {
            this.sideBetBtnOnClick()
        }
        return isClickValid
    }
    //下旁注
    sideBetBtnOnClick() {

        if (this.posInfoArr.length > 0 && this.posInfoArr[0].playerId != this.mainPlayerInfo.playerId) //main玩家点其他玩家的旁注
        {
            if (this.sideBetInfo == null || this.sideBetInfo.base == 0)//这个旁注main还没下
            {
                //cc.log("betView发送旁注"+this.seatNo)
                if (this.posInfoArr.length > 0 && this.posInfoArr[0].base != 0) //这个位置玩家已经下了旁注
                {
                    this.blackjackLogic.betOther(this.seatNo)
                }
                else {
                    ModuleManager.instance.toast("该座位玩家尚未下底注");
                }
            }
            else {
                ModuleManager.instance.toast("请勿重复下注该座位旁注");
            }
        }
    }
    //多占一个位置
    seatBtnOnClick() {

        this.showNotice(false)
        this.lights[0].active = true;
        this.blackjackLogic.moreBetPos(this.seatNo)
    }

    checkSeatNo() {
        let playerPos = 2
        let dis = playerPos - Number(this.parentNode.name)
        let index = 0;
        if (2 + dis < 5 && dis >= -2) {
            index = 2 + dis;
        }
        else if (2 + dis > 4) {
            index = 2 + dis - 5
        }
        else {
            index = dis + 7
        }
        return index
    }

    setBlackJackTableView(b: BlackJackTableView) {
        this.blackJackView = b;
    }
    setParentPos(nodeParent: cc.Node) {
        this.parentNode = nodeParent
        //this.otherBet.angle=-this.parentNode.angle
        //this.ohterBetLight.angle=-this.otherBet.angle
        let pos = this.blackJackView.chipPos.getChildByName(this.parentNode.name)
        this.chipPosList.push(pos.getChildByName("base"))
        this.chipPosList.push(pos.getChildByName("pair"))
        this.chipPosList.push(pos.getChildByName("three"))
        this.chipPosList.push(pos.getChildByName("side"))
        this.chipPosList.push(pos.getChildByName("insurance"))
        this.chipPosList.push(pos.getChildByName("leftbase"))
        this.chipPosList.push(pos.getChildByName("rightbase"))
    }

    quickBetNum() {

        this.curBetSetp = 3;
        this.blackJackView.mySeatCompleteBet()
    }
    // setBetSkip()
    // {
    //     if(this.posInfoArr.base==0)
    //     {
    //         ModuleManager.instance.toast("请先下底注");
    //         return;
    //     }
    //     this.curBetSetp+=1;
    //     if(this.curBetSetp>2)
    //     {
    //         this.blackJackView.mySeatCompleteBet()
    //     }
    // }

    showNotice(isShow: boolean = true, str: string = "") {
        this.otherBet.active = isShow;
        switch (str) {
            case "Bet":
                this.leftPointNode.active = false
                this.rightPointNode.active = false;
                this.singlePointNode.active = false;
                this.curBetSetp = 0;
                this.ohterBetTxt.string = LanguageManager.t("bj_Click_Bet")
                break;
            case "Insurance":
                this.ohterBetTxt.string = LanguageManager.t("bj_Let_Insurance") + this.seatNo
                break;
            case "ErrNo3":
                this.ohterBetTxt.string = LanguageManager.t(str)
                break;
            case "ErrNo4":
                this.ohterBetTxt.string = LanguageManager.t(str)
                break;
            case "ErrNo5":
                this.ohterBetTxt.string = LanguageManager.t("bj_Not_Money")
                break;
        }
    }
    addPosInfo(info: BlackJack.IPosInfo, startNode: cc.Node = null) {

        this.checkPosInfo(info)
        if (this.posInfoArr[0].b21p3 != 0) {
            this.curBetSetp = 3
            return;
        }
        if (this.posInfoArr[0].pair != 0) {
            this.curBetSetp = 2
            return;
        }
        if (this.posInfoArr[0].base != 0) {
            this.curBetSetp = 3
            return
        }
        this.curBetSetp = 0

    }
    chipMove(startNode: cc.Node, endPos: cc.Node, effect: BlackJackBetMoveEffect, num: number, isRecycle: boolean = false) {
        if (startNode == null) {
            return
        }
        if (isRecycle) {
            effect.purposeNode = startNode
            effect.recycleAllBet()
        }

        effect.startNode = startNode
        effect.purposeNode = endPos
        effect.checkBet(num);


    }
    chipMoveBack(reason: number, endNode: cc.Node, pos: number) {

        this.clearReason(reason)
        let moveEffect: BlackJackBetMoveEffect = null
        let startNode = null
        moveEffect = this.getEffectByReason(reason, pos)
        if (reason == GameResultState.GameOver || reason == GameResultState.bombPoker) {
            if (pos > 5) {
                startNode = this.chipPosList[BlackJackChipPos.rightBase]
            }
            else {
                if (this.posInfoArr.length == 1) {
                    startNode = this.chipPosList[BlackJackChipPos.base]
                }
                else {
                    startNode = this.chipPosList[BlackJackChipPos.leftBase]
                }
            }
            moveEffect.purposeNode = startNode
        }

        moveEffect.guiChi(endNode);

    }
    checkPosInfo(info: BlackJack.IPosInfo) {
        if (info != null) {
            if (this.posInfoArr.length == 0) //如果没有posInfo就是添加
            {
                this.posInfoArr.push(info)
            }
            else {
                if (this.posInfoArr[0].pos == info.pos) //如果相同Pos 就是修改
                {
                    this.posInfoArr[0] = info
                }
                else// pos不相同 就是添加
                {
                    this.posInfoArr.push(info)
                }
            }
        }
        if (this.posInfoArr.length > 0) {
            this.buttons.active = true
        }

    }
    showLights() {
        this.lightsRest()
        if (this.blackjackLogic.gameState != BlackJackGameState.Beting) {
            return
        }

        if (this.curBetSetp <= 2 && this.posInfoArr[0].playerId == this.mainPlayerInfo.playerId && this.posInfoArr[0].isMainSeat) {

            this.lights[this.curBetSetp].active = true
        }

    }
    addCardInfo(pos: number, info: BlackJack.ICardInfo, isShow: boolean = true) {
        if (info != null) {
            for (let i = 0; i < this.posInfoArr.length; i++) {
                if (this.posInfoArr[i].pos == pos) {
                    this.posInfoArr[i].cardInfo = info
                }
            }
        }
        if (isShow) {
            this.showPanel()
        }


    }


    //下注后 修改玩家的金额
    modifyPosInfo(startNode: cc.Node, pos: number, type: number, coin: number) {//下注类型 0 表示 底注 1表示完美对子 2表示21+3 4续压 5旁注
        //cc.log("betView下注"+this.seatNo)
        for (let i = 0; i < this.posInfoArr.length; i++) {
            if (this.posInfoArr[i].pos == pos) {
                if (type == BlackJackBetType.base) {
                    this.chipMove(startNode, this.chipPosList[BlackJackChipPos.base], this.baseEffect, coin)
                    this.posInfoArr[i].base = coin
                    this.curBetSetp = 1


                }
                else if (type == BlackJackBetType.pair) {
                    this.chipMove(startNode, this.chipPosList[BlackJackChipPos.pair], this.pairEffect, coin)
                    this.posInfoArr[i].pair = coin
                    this.curBetSetp = 2
                }
                else if (type == BlackJackBetType.three) {
                    this.chipMove(startNode, this.chipPosList[BlackJackChipPos.three], this.threeEffect, coin)
                    this.posInfoArr[i].b21p3 = coin
                    this.curBetSetp = 3
                }
                else if (type == BlackJackBetType.side) {
                    this.chipMove(startNode, this.chipPosList[BlackJackChipPos.side], this.sideEffect, coin)
                    this.posInfoArr[i].b21p3 = coin
                    this.curBetSetp = 3
                }
                break;
            }
        }
        this.curBetSetp = 3
        this.showPanel();
    }
    showPanel() {
        if (this.posInfoArr.length == 0) {
            this.buttons.active = false;
            return
        }
        this.buttons.active = true;



        this.showCardInfo()
        this.showLights()
    }
    setBetInfo() {
        //cc.log("====================="+this.seatNo,this.posInfoArr.length)
        if (this.posInfoArr.length > 0) {
            //this.showBetInfo(this.baseEffect,this.posInfoArr[0].base,this.chipPosList[BlackJackChipPos.base])
            if (this.posInfoArr.length == 2) {
                this.showBetInfo(this.baseEffect, this.posInfoArr[0].base, this.chipPosList[BlackJackChipPos.leftBase])
                this.showBetInfo(this.baseRightEffect, this.posInfoArr[1].base, this.chipPosList[BlackJackChipPos.rightBase])
                this.leftCoinBg.position = new cc.Vec2(-45, -77)
                this.delayShowCoin(this.posInfoArr[0].pos, this.posInfoArr[0].base)
                this.delayShowCoin(this.posInfoArr[1].pos, this.posInfoArr[1].base)
            }
            else {

                if (this.posInfoArr[0].base != 0) {

                    this.leftCoinBg.position = new cc.Vec2(0, -77)
                    this.delayShowCoin(this.posInfoArr[0].pos, this.posInfoArr[0].base)
                }

                this.showBetInfo(this.baseEffect, this.posInfoArr[0].base, this.chipPosList[BlackJackChipPos.base])
            }
        }
    }
    showBetInfo(moveEffect: BlackJackBetMoveEffect, coin: number, endNode: cc.Node) {
        if (coin != 0) {

            moveEffect.purposeNode = endNode
            moveEffect.showBet(coin);
        }
    }

    //显示牌
    showPoker() {

        if (this.isNotCard()) {
            return;
        }
        if (this.posInfoArr.length == 1) {
            this.pokerPos.destroyAllChildren()
            this.pokerPrefabList = [];
            for (let i = 0; i < this.posInfoArr[0].cardInfo.cards.length; i++) {
                let code = this.posInfoArr[0].cardInfo.cards[i]
                let poker: PokerTablePokerBase = BlackJackUtility.makePoker(this.blackJackView.pokerPrefab.node, code, this.pokerPos, i)
                poker.node.position = new cc.Vec2(poker.node.position.x + i * 30, 0)
                this.pokerPrefabList.push(poker)
            }
        }
        else {
            this.leftPokerPos.destroyAllChildren()
            this.rightPokerPos.destroyAllChildren()
            for (let i = 0; i < this.posInfoArr.length; i++) {
                for (let j = 0; j < this.posInfoArr[i].cardInfo.cards.length; j++) {
                    let code = this.posInfoArr[i].cardInfo.cards[j]
                    let parentCode: cc.Node = null
                    if (i == 0) {
                        parentCode = this.leftPokerPos
                    }
                    else {
                        parentCode = this.rightPokerPos
                    }
                    let poker: PokerTablePokerBase = BlackJackUtility.makePoker(this.blackJackView.pokerPrefab.node, code, parentCode, j)
                    poker.node.position = new cc.Vec2(poker.node.position.x + j * 30, 0)
                }
            }
        }
    }
    showCardInfo()
    {
        
        if(this.isNotCard())
        {
            this.singlePointNode.active=false;
            this.leftPointNode.active=false;
            this.rightPointNode.active=false;
            return
        }
        if(this.posInfoArr.length==1)
        {
            this.leftPointNode.active=false;
            this.rightPointNode.active=false
            this.leftPokerPos.active=false;
            this.rightPokerPos.active=false;
            
            
            this.singlePointNode.active=true;
            
            
            this.showPoint(this.singlePointTxt,this.posInfoArr[0].cardInfo)
        }
        else
        {
            this.leftPokerPos.active=true;
            this.rightPokerPos.active=true;
            this.leftPointNode.active=true;
            this.rightPointNode.active=true;
            
            this.singlePointNode.active=false;
            this.showPoint(this.leftPointTxt,this.posInfoArr[0].cardInfo)
            if(this.posInfoArr[1].cardInfo!=null)
            {
                this.showPoint(this.rightPointTxt,this.posInfoArr[1].cardInfo)
            } 
        }
        
    }

    delayShowPoint() {
        this.blackJackView.doSchedule(() => {
            this.showCardInfo()

        }, 0.85);
    }
    delayShowCoin(pos: number, coin: number,isShow=true) {
        if (coin == 0)
            return
            this.blackJackView.doSchedule(() => {

            if (pos > 5) {
                this.rightCoinBg.active = isShow
                this.rightBaseNumTxt.string = GameUtil.currencyFormatting(coin)
            }
            else {
                this.leftCoinBg.active = isShow
                this.leftBaseNumTxt.string = GameUtil.currencyFormatting(coin)
            }
        }, 0.5);
    }
    showPoint(txt: cc.Label, cardInfo: BlackJack.ICardInfo) {
        if (cardInfo.cards.length < 1) {
            return
        }
        
        let parent = txt.node.parent.parent
        
        
        
        let state = parent.getChildByName("pokerState")
        state.active = false;
        let pointBg = parent.getChildByName("pointBg")
        let bombEffect = parent.getChildByName("BombEffect").getComponent(cc.Animation)

        // 
        pointBg.active=false
        if (cardInfo.status == BlackJackCardState.Bomb) {
            pointBg.active = true;
            txt.string = ""//LanguageManager.t("bj_Bomb")
            if (!bombEffect.node.active) {
                bombEffect.node.active = true
                bombEffect.play()
            }
            let hidePos=0

            if(parent.name=="2")
            {
                hidePos=6
            }
            this.delayShowCoin(hidePos,1,false)

        }
        else if (cardInfo.status == BlackJackCardState.Blackjack) {
            bombEffect.node.active = false
            state.active = true;
            state.getChildByName("blackjack").active = true
            state.getChildByName("five").active = false;
        }
        else if (cardInfo.status == BlackJackCardState.Five_Dragon) {
            bombEffect.node.active = false
            state.active = true;
            state.getChildByName("blackjack").active = false
            state.getChildByName("five").active = true;
        }
        else {
            bombEffect.node.active = false
            pointBg.active = true;
            
            txt.string = cardInfo.cardPoint[0].toString();
            
            if (cardInfo.cardPoint.length > 1) {
                txt.string = cardInfo.cardPoint[1].toString() + "/" + cardInfo.cardPoint[0].toString();
            }
        }

        
    }

    showPokerSeparate(protoData: BlackJack.EnableRightNotify = null) {
        if (this.pokerPrefabList.length != 2) {
            ModuleManager.instance.toast("当前数量不对，不能分牌");
            return;
        }
        let posInfo2: BlackJack.PosInfo = new BlackJack.PosInfo()
        Object.assign(posInfo2, this.posInfoArr[0]);
        this.posInfoArr.push(posInfo2)
        this.posInfoArr[1].pos = this.posInfoArr[0].pos + 5;
        this.posInfoArr[0].cardInfo = protoData.leftCardInfo


        this.posInfoArr[1].cardInfo = protoData.rightCardInfo
        let func: Function = this.pokerMoveDone;

        let leftLocal = BlackJackUtility.getConvertToNodeSpaceAR(this.pokerPos, this.leftPokerPos)
        let rightLocal = BlackJackUtility.getConvertToNodeSpaceAR(this.pokerPos, this.rightPokerPos)

        this.leftCoinBg.active = false

        BlackJackUtility.moveToAction(this.pokerPrefabList[0].node, leftLocal, 0.3, func.bind(this))
        BlackJackUtility.moveToAction(this.pokerPrefabList[1].node, rightLocal, 0.3)


    }
    pokerMoveDone() {

        this.leftCoinBg.position = new cc.Vec2(-45, -77)
        this.leftBaseNumTxt.string = this.posInfoArr[0].base.toString()
        this.rightBaseNumTxt.string = this.posInfoArr[0].base.toString()
        this.leftCoinBg.active = true
        this.rightCoinBg.active = true


        this.leftPokerPos.active = true;
        this.rightPokerPos.active = true;
        // this.leftPointNode.active=true;
        // this.rightPointNode.active=true;
        this.singlePointNode.active = false;

        this.pokerPrefabList[0].node.parent = this.leftPokerPos
        this.pokerPrefabList[1].node.parent = this.rightPokerPos
        this.pokerPrefabList[0].node.position = cc.v2(0, 0)
        this.pokerPrefabList[1].node.position = cc.v2(0, 0)
        this.pokerPrefabList = [];
        this.singlePointTxt.string = ""
        this.blackjackLogic.makePokerMove(this.seatNo, this, this.posInfoArr[0].cardInfo.cards)
        this.blackjackLogic.makePokerMove(this.seatNo + 5, this, this.posInfoArr[1].cardInfo.cards)
        this.buttons.active = true;
        this.blackJackView.doSchedule(() => {

            this.showCardInfo()
        }, 1);
        //this.showPanel()
    }
    PokerMask(pos: number) {

        if (pos == -1) {
            this.showPokerMask(this.pokerPos, false)
            this.showPokerMask(this.leftPokerPos, false)
            this.showPokerMask(this.rightPokerPos, false)
            return;
        }
        let parent: cc.Node = null
        if (pos > 5) {
            parent = this.leftPokerPos
        }
        else {
            if (this.posInfoArr.length == 2) {
                parent = this.rightPokerPos
            }
        }
        if (parent) {
            this.showPokerMask(parent)
        }
    }
    showPokerMask(parent: cc.Node, isShow = true) {
        for (let i = 0; i < parent.childrenCount; i++) {
            let poker: PokerTablePokerBase = parent.children[i].getComponent(PokerTablePokerBase)
            if (poker) {
                poker.mask.active = isShow;
            }
        }
    }
    setSeatNo(num: number) {
        this.seatNo = num
    }
    showSideBetBtn() {
        return;
        this.sideBetBtn.node.active = false;
        this.lights[3].active = false;
        if (this.mainPlayerInfo.playerPos == 0 && this.posInfoArr.length > 0) {
            if (this.posInfoArr[0].base != 0 && this.blackjackLogic.gameState == BlackJackGameState.Beting) {
                this.sideBetBtn.node.active = true;
                this.lights[3].active = true;
            }
        }
    }
    changeSetp() {
        this.curBetSetp = 3
    }
    // setSideInfo(betInfo: BlackJack.Player.IBetInfo, startNode: cc.Node = null, ) {

    //     this.sideBetInfo = betInfo
    //     if (this.sideBetInfo != null) {
    //         if (startNode != null) {
    //             this.sideEffect.startNode = startNode
    //             this.sideEffect.purposeNode = this.chipPosList[BlackJackChipPos.side]
    //             this.sideEffect.checkBet(betInfo.base)
    //         }
    //         else {
    //             this.showBetInfo(this.sideEffect, this.sideBetInfo.base, this.chipPosList[BlackJackChipPos.side])
    //         }
    //     }
    // }
    getBetSetp() {

        return this.curBetSetp
    }
    setMainPlayerInfo(mainPlayerInfo: BlackJack.IPlayer) {
        this.mainPlayerInfo = mainPlayerInfo;
    }
    isNotCard() {
        if (this.posInfoArr.length == 0 || this.posInfoArr[0].cardInfo == null || this.posInfoArr[0].cardInfo.cards.length == 0) {
            return true
        }
        return false;
    }
    setLogic(bjLogic: BlackJackTableLogic) {
        if (this.blackjackLogic == null && bjLogic != null) {
            this.blackjackLogic = bjLogic;
        }
    }
    clearReason(reason: number) {
        switch (reason) {
            case GameResultState.GameOver:
                this.posInfoArr[0].base = 0;
                break;
            case GameResultState.GameOver:
                this.posInfoArr[0].insurance = 0;
                break;
            case GameResultState.PairPoker:
                this.posInfoArr[0].pair = 0;

                break;
            case GameResultState.ThreePoker:
                this.posInfoArr[0].b21p3 = 0;
                break;
            case GameResultState.bombPoker:
                this.posInfoArr[0].base = 0;
                break;
        }
    }
    getCardInfo(curOperate: number) {
        if (curOperate > 5) {
            return this.posInfoArr[1]
        }
        else {
            return this.posInfoArr[0]
        }
    }
    getEffectByReason(reason: number, pos: number = 0) {
        //结算原因 1保险 2完美对子结算 3、21+3结算 4、爆牌结算

        switch (reason) {
            case GameResultState.GameOver:
                if (pos > 5) 
                {
                    
                    return this.baseRightEffect
                }
                else
                {
                    if(this.chipPosList[BlackJackChipPos.rightBase].childrenCount>0)
                    {
                        this.baseEffect.purposeNode=this.chipPosList[BlackJackChipPos.leftBase]
                    }
                    return this.baseEffect
                }
                
            case GameResultState.Insurance:
                return this.insuranceEffect
            case GameResultState.PairPoker:
                return this.pairEffect
            case GameResultState.ThreePoker:
                return this.threeEffect
            case GameResultState.bombPoker:
                if (pos > 5) {
                    
                    return this.baseRightEffect
                }
                else
                {
                    if(this.chipPosList[BlackJackChipPos.rightBase].childrenCount>0)
                    {
                        this.baseEffect.purposeNode=this.chipPosList[BlackJackChipPos.leftBase]
                    }
                    return this.baseEffect
                }
        }
    }
    // getNodeByReason(reason: number) {
    //     //结算原因 1保险 2完美对子结算 3、21+3结算 4、爆牌结算
    //     switch (reason) {
    //         case 0:
    //             return this.chipPosList[BlackJackChipPos.base]
    //         case 1:
    //             return this.chipPosList[BlackJackChipPos.insurance]
    //         case 2:
    //             return this.chipPosList[BlackJackChipPos.pair]
    //         case 3:
    //             return this.chipPosList[BlackJackChipPos.three]
    //         case 4:
    //             return this.chipPosList[BlackJackChipPos.base]

    //     }
    // }


}
